import { CURRENCY, QUOTE_CLASSIFICATION } from 'src/constants/common';

export const defaultWidgets = [
    {
        id: 'map-it',
        title: 'Map-It',
        description: 'Compared and visualized by geographical regions',
        enabled: true,
    },
    {
        id: 'predictive-index',
        title: 'Predictive Index',
        description: 'Analyze performance based on predictive index values',
        enabled: true,
    },
    {
        id: 'customer',
        title: 'Customer',
        description: 'See customer profile and engagement insights',
        enabled: true,
    },
    {
        id: 'threads',
        title: 'Threads',
        description: 'View all conversations linked to this customer',
        enabled: true,
    },
];
export const LIMITED_ACCESS_LIST = [
    { name: 'Construction Site', value: 'construction-site' },
    { name: 'Individual (Mini) Storage Unit', value: 'mini-storage-unit' },
    { name: 'Fair/Amusement Park', value: 'fair' },
    { name: 'Place of Worship', value: 'place-of-worship' },
    { name: 'Farm/Country Club/Estate', value: 'farm' },
    {
        name: 'Secured Locations Delivery - prisons, military bases, airport',
        value: 'secured-location',
    },
    { name: 'School/University', value: 'school' },
    { name: 'Plaza/Mall with only parking lot/Street access', value: 'mall' },
    { name: 'Airport', value: 'airport' },
    { name: 'Cemetery', value: 'cemetery' },
    { name: 'Church', value: 'church' },
    { name: 'Convention Center', value: 'convention-center' },
    { name: 'Funeral Home', value: 'funeral-home' },
    { name: 'Golf Course', value: 'golf-course' },
    { name: 'Grocery Warehouse', value: 'grocery-warehouse' },
    { name: 'Hospital/Medical Facility', value: 'hospital-medical-facility' },
    { name: 'Hotel', value: 'hotel' },
    { name: 'Inspection Site', value: 'inspection-site' },
    { name: 'Marina', value: 'marina' },
    { name: 'Military Base', value: 'military-base' },
    { name: 'Mine Site', value: 'mine-site' },
    { name: 'No Dock/Dock obstruction', value: 'no-dock-dock-obstruction' },
    { name: 'Nursing Home', value: 'nursing-home' },
    { name: 'Park Forest/Preserve', value: 'park-forest-preserve' },
    { name: 'Piers and Wharves', value: 'piers-and-wharves' },
    { name: 'Prison', value: 'prison' },
    { name: 'Ranch', value: 'ranch' },
    {
        name: 'Recreational/athletic Facility',
        value: 'recreational-athletic-facility',
    },
    { name: 'Remote Government', value: 'remote-government' },
    { name: 'Reservation', value: 'reservation' },
    { name: 'Restaurant', value: 'restaurant' },
    { name: 'Service Station', value: 'service-station' },
    { name: 'Social Club', value: 'social-club' },
    { name: 'Steel Mill', value: 'steel-mill' },
    { name: 'Unspecified', value: 'unspecified' },
    { name: 'Utility Site', value: 'utility-site' },
    { name: 'Winery/Brewery/Distillery', value: 'winery-brewery-distillery' },
    { name: 'Other', value: 'other' },
];

export const CLASSIFICATION_OPTIONS = [
    {
        label: 'LTL',
        value: QUOTE_CLASSIFICATION.LTL,
    },
    {
        label: 'FTL',
        value: QUOTE_CLASSIFICATION.FTL,
    },
];

const QUOTE_TABS = {
    ADDRESS: 'address',
    QUOTE_DETAIL: 'quote_detail',
    DIMENSIONS: 'dimensions',
};

export const QUOTE_DETAIL_TABS = [
    {
        value: QUOTE_TABS.ADDRESS,
        name: 'Address',
        permission: [QUOTE_CLASSIFICATION.LTL, QUOTE_CLASSIFICATION.FTL],
    },
    {
        value: QUOTE_TABS.QUOTE_DETAIL,
        name: 'Quote Detail',
        permission: [QUOTE_CLASSIFICATION.LTL, QUOTE_CLASSIFICATION.FTL],
    },
    {
        value: QUOTE_TABS.DIMENSIONS,
        name: 'Dimensions',
        permission: [QUOTE_CLASSIFICATION.LTL],
    },
];

export const MAX_DIMENSION_LIMIT = 15;
export const MAX_DIMENSION_LIMIT_FTL = 50;
export const initialQuoteDetailAction = {
    service: false,
    inBond: false,
    loadInsurance: false,
    dangerousGoods: false,
};
export const initAction = {
    mode: '',
    shipper: false,
    consignee: false,
    tailgate: false,
    unusual: false,
    service: false,
    delivery: false,
    limitedAccess: false,
    pickupDate: false,
};

export const currencies = [
    {
        value: CURRENCY.CAD,
        label: 'CAD',
    },
    {
        value: CURRENCY.USD,
        label: 'USD',
    },
];

export const RATE_TYPE_OPTIONS = [
    { label: 'Common Carrier Rates', value: 'common_carrier_rates' },
    { label: 'Spot Quote Rates', value: 'spot_quote_rates' },
];

export const initCommonCarrier = {
    activeQuote: false,
    refreshRates: false,
};

export const CARRIER_RATES_LIMIT_OPTIONS = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
];

export const LOCATION_STATE_TO_STORAGE_CONFIG = (id: string | undefined | null = '', excludeKeys: string[] = []) => {
    const allConfigs = [
        {
            stateKey: 'activeCarrierCount',
            storageKey: id ? `activeCarrierCount_${id}` : '',
            transform: (value: any) => value.toString(),
        },
        { stateKey: 'primaryEquipmentTypeFullName' },
        { stateKey: 'classification' },
        { stateKey: 'code' },
        { stateKey: 'totalLoadPost' },
        { stateKey: 'isSpotQuoteShow' },
        {
            stateKey: 'addressDetails',
            shouldStore: (value: any) => value && typeof value === 'object' && Object.keys(value).length > 0,
        },
    ];

    return allConfigs.filter((config) => !excludeKeys.includes(config.stateKey));
};

export const DUMMY_CARRIER_RATES = [
    {
        carrierId: 1001,
        name: 'FedEx Freight',
        carrierName: 'FedEx Freight',
        carrierQuoteId: 'FDX-2025-001234',
        imageUrl: '',
        image: '',
        isFreightcom: false,
        isBanyan: false,
        isAmericanGroup: false,
        isLFS: false,
        transitTime: 3,
        totalCharge: 1850.0,
        totalChargeUSD: 1387.5,
        additionalCharges: 125.0,
        additionalChargesUSD: 93.75,
        finalCharge: 1975.0,
        finalChargeUSD: 1481.25,
        totalCostCAD: 1975.0,
        margin: 150.0,
        marginUSD: 112.5,
        carrierCurrency: CURRENCY.CAD,
        banyanPostFix: '',
        isLoading: false,
        services: [
            {
                serviceName: 'Base Freight',
                charge: 1500.0,
                chargeUSD: 1125.0,
                isQuoted: true,
            },
            {
                serviceName: 'Fuel Surcharge',
                charge: 225.0,
                chargeUSD: 168.75,
                isQuoted: true,
            },
            {
                serviceName: 'Liftgate Service',
                charge: 125.0,
                chargeUSD: 93.75,
                isQuoted: true,
            },
        ],
    },
    {
        carrierId: 1002,
        name: 'XPO Logistics',
        carrierName: 'XPO Logistics',
        carrierQuoteId: 'XPO-2025-005678',
        imageUrl: '',
        image: '',
        isFreightcom: true,
        isBanyan: false,
        isAmericanGroup: false,
        isLFS: false,
        transitTime: 2,
        totalCharge: 2100.0,
        totalChargeUSD: 1575.0,
        additionalCharges: 175.0,
        additionalChargesUSD: 131.25,
        finalCharge: 2275.0,
        finalChargeUSD: 1706.25,
        totalCostCAD: 2275.0,
        margin: 200.0,
        marginUSD: 150.0,
        carrierCurrency: CURRENCY.CAD,
        banyanPostFix: '',
        isLoading: false,
        services: [
            {
                serviceName: 'Base Freight',
                charge: 1700.0,
                chargeUSD: 1275.0,
                isQuoted: true,
            },
            {
                serviceName: 'Fuel Surcharge',
                charge: 225.0,
                chargeUSD: 168.75,
                isQuoted: true,
            },
            {
                serviceName: 'Residential Delivery',
                charge: 175.0,
                chargeUSD: 131.25,
                isQuoted: true,
            },
        ],
    },
    {
        carrierId: 1003,
        name: 'Estes Express Lines',
        carrierName: 'Estes Express Lines',
        carrierQuoteId: 'EST-2025-009012',
        imageUrl: '',
        image: '',
        isFreightcom: false,
        isBanyan: true,
        isAmericanGroup: false,
        isLFS: false,
        banyanPostFix: '(Premium)',
        transitTime: 4,
        totalCharge: 1650.0,
        totalChargeUSD: 1237.5,
        additionalCharges: 0,
        additionalChargesUSD: 0,
        finalCharge: 1650.0,
        finalChargeUSD: 1237.5,
        totalCostCAD: 1650.0,
        margin: 100.0,
        marginUSD: 75.0,
        carrierCurrency: CURRENCY.CAD,
        isLoading: false,
        services: [
            {
                serviceName: 'Base Freight',
                charge: 1400.0,
                chargeUSD: 1050.0,
                isQuoted: true,
            },
            {
                serviceName: 'Fuel Surcharge',
                charge: 250.0,
                chargeUSD: 187.5,
                isQuoted: true,
            },
        ],
    },
    {
        carrierId: 1004,
        name: 'Old Dominion',
        carrierName: 'Old Dominion',
        carrierQuoteId: 'OD-2025-003456',
        imageUrl: '',
        image: '',
        isFreightcom: false,
        isBanyan: false,
        isAmericanGroup: true,
        isLFS: false,
        transitTime: 5,
        totalCharge: 1550.0,
        totalChargeUSD: 1162.5,
        additionalCharges: 95.0,
        additionalChargesUSD: 71.25,
        finalCharge: 1645.0,
        finalChargeUSD: 1233.75,
        totalCostCAD: 1645.0,
        margin: 125.0,
        marginUSD: 93.75,
        carrierCurrency: CURRENCY.CAD,
        banyanPostFix: '',
        isLoading: false,
        services: [
            {
                serviceName: 'Base Freight',
                charge: 1300.0,
                chargeUSD: 975.0,
                isQuoted: true,
            },
            {
                serviceName: 'Fuel Surcharge',
                charge: 155.0,
                chargeUSD: 116.25,
                isQuoted: true,
            },
            {
                serviceName: 'Inside Delivery',
                charge: 95.0,
                chargeUSD: 71.25,
                isQuoted: true,
            },
        ],
    },
    {
        carrierId: 1005,
        name: 'R+L Carriers',
        carrierName: 'R+L Carriers',
        carrierQuoteId: 'RL-2025-007890',
        imageUrl: '',
        image: '',
        isFreightcom: false,
        isBanyan: false,
        isAmericanGroup: false,
        isLFS: true,
        transitTime: 6,
        totalCharge: 1425.0,
        totalChargeUSD: 1068.75,
        additionalCharges: 150.0,
        additionalChargesUSD: 112.5,
        finalCharge: 1575.0,
        finalChargeUSD: 1181.25,
        totalCostCAD: 1575.0,
        margin: 75.0,
        marginUSD: 56.25,
        carrierCurrency: CURRENCY.CAD,
        banyanPostFix: '',
        isLoading: false,
        services: [
            {
                serviceName: 'Base Freight',
                charge: 1200.0,
                chargeUSD: 900.0,
                isQuoted: true,
            },
            {
                serviceName: 'Fuel Surcharge',
                charge: 75.0,
                chargeUSD: 56.25,
                isQuoted: true,
            },
            {
                serviceName: 'Limited Access',
                charge: 150.0,
                chargeUSD: 112.5,
                isQuoted: true,
            },
        ],
    },
];

export const DANGER_TYPE_LIST = [
    { name: 'Limited Quantity', value: 'limited-quantity' },
    { name: '500 kg Exemption', value: 'exemption-500-kg' },
    { name: 'Fully Regulated', value: 'fully-regulated' },
];

export const PACKAGING_GROUP_OPTIONS = [
    { label: 'PG I', value: 'PGI' },
    { label: 'PG II', value: 'PGII' },
    { label: 'PG III', value: 'PGIII' },
];

export const EDIT_QUOTE_ERROR_FIELDS = {
    SHIPPER_DETAILS: [
        'shipperFullAddress',
        'shipperLatitude',
        'shipperLongitude',
        'shipperCity',
        'shipperState',
        'shipperCountry',
        'shipperStreetNumber',
        'shipperPostal',
        'shipperCompanyName',
        'pickupDate',
        'pickupSensitivity',
        'pickupEndDate',
        'pickupWindowType',
        'pickupStartTime',
        'pickupEndTime',
    ],
    CONSIGNEE_DETAILS: [
        'consigneeFullAddress',
        'consigneeLatitude',
        'consigneeLongitude',
        'consigneeCity',
        'consigneeState',
        'consigneeCountry',
        'consigneeStreetNumber',
        'consigneePostal',
        'consigneeCompanyName',
        'deliverySensitivity',
        'deliveryDate',
        'deliveryEndDate',
        'deliveryWindowType',
        'deliveryStartTime',
        'deliveryEndTime',
    ],
    SHIPMENT_DETAILS: ['classification', 'urgency', 'primaryEquipmentType', 'primaryEquipmentTypeFullName', 'weightMeasurement', 'lengthMeasurement', 'insuranceCommodity', 'insuranceCommercialValue'],
    DIMENSIONS: ['dimensions', 'totalWeight', 'linearFootage'],
    FTL: ['totalWeight', 'linearFootage'],
};

export const TAILGATE_SERVICE_IDS = {
    TAILGATE: 'tailgate',
    NO_TAILGATE: 'no-tailgate',
};

export const initialQuoteAction = {
    weightMismatch: false,
    linearFootageMismatch: false,
    weightLinearFootageMismatch: false,
    tailgate: false,
    data: null,
};

export const shipperFormKeys: Record<string, string> = {
    shipperFullAddress: 'fullAddress',
    shipperAddress1: 'address1',
    shipperCity: 'city',
    shipperState: 'state',
    shipperCountry: 'country',
    shipperPostal: 'postal',
    shipperLatitude: 'latitude',
    shipperLongitude: 'longitude',
    shipperStateCode: 'stateCode',
    shipperCountryCode: 'countryCode',
    shipperStreetNumber: 'streetNumber',
    shipperCompanyName: 'companyName',
};

export const consigneeFormKeys: Record<string, string> = {
    consigneeFullAddress: 'fullAddress',
    consigneeAddress1: 'address1',
    consigneeCity: 'city',
    consigneeState: 'state',
    consigneeCountry: 'country',
    consigneePostal: 'postal',
    consigneeLatitude: 'latitude',
    consigneeLongitude: 'longitude',
    consigneeStateCode: 'stateCode',
    consigneeCountryCode: 'countryCode',
    consigneeStreetNumber: 'streetNumber',
    consigneeCompanyName: 'companyName',
};
